import React, {FunctionComponent, useContext, useEffect, useState} from 'react';
import {Context} from '../../../../../store/context';
import SwitchControl from '../../SwitchControl/SwitchControl';
import {observer} from "mobx-react";
import {ChannelParam} from "../../../../../store/QueryParamsStore/QueryParamsEnums";
import { analytics } from '../../../../..';
import { AnalyticsEvents } from '../../../../../store/AnalyticsStore';

interface ILinks {
}

const Links: FunctionComponent<ILinks> = observer(() => {
    const {queryParamsStore, linksStore} = useContext(Context);
    const {queryParams, setQueryParam} = queryParamsStore;
    const {link, useShortLink, shortLink, setUseShortLink, getShortLink} = linksStore;

    if(!queryParams) return null;

    const setFixStart = (checked: boolean) => {
      setUseShortLink(false);
      analytics.logEvent(AnalyticsEvents.ToggleBlockStartingPosition, {value: checked})
      const newParams = {...queryParams};
      const fixStart = checked ? 'true' : '';
      newParams.fixStart = fixStart;
      setQueryParam(newParams);
    };

    useEffect(() => {
        if(!useShortLink) return;
       getShortLink();
    }, [useShortLink]);

    const linkWithLinkCopyChannel = new URL('', link);
    linkWithLinkCopyChannel.searchParams.set('channel', ChannelParam.LinkCopy);

    return (
        <div>
            <div className="row">
                <div className="col-sm-offset-1 col-md-offset-1 col-xs-offset-1">
                    { useShortLink && !shortLink
                        ?
                        <span>Creating short link... <i className="icon-spinner2 spinner"/></span>
                        :
                        <a
                            className="link text-overflow"
                            href={useShortLink ? shortLink : linkWithLinkCopyChannel.href}
                            target="_blank"
                            id="link">
                            {useShortLink ? shortLink : linkWithLinkCopyChannel.href}
                        </a>
                    }
                </div>
            </div>
            <div className="row">
                <div className="col-md-offset-1 col-xs-offset-1 col-sm-offset-1">
                    <SwitchControl
                        label = "Use short link"
                        checked = {useShortLink}
                        onChange = {(checked) => {
                            analytics.logEvent(AnalyticsEvents.ToggleUseShortLink, {value: checked})
                            setUseShortLink(checked)
                        }}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-offset-1 col-xs-offset-1 col-sm-offset-1">
                    <SwitchControl
                        label = "Block starting position"
                        checked = {!!queryParams.fixStart}
                        onChange = {setFixStart}
                    />
                </div>
            </div>
        </div>
    )
});


export default Links;
